module.exports = {"key":"faktabank","html":"<p>Denna guide gäller märkning och marknadsföring i Sverige.\nI andra länder måste du ta hänsyn till de nationella regler\nsom kan finnas där.</p>\n<p>Guiden har tagits fram för att vara till hjälp och göra det\nenklare att använda kostråden i märkning och marknadsföring.\nMen det är alltid det enskilda företaget som beslutar om hur\nkostråden används och ansvarar för att lagen följs.</p>\n"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/faktabank/faktabank.md
// module id = 706
// module chunks = 1